import questionnaireTypes from './questionaire.types';

/** ***************** GET QUESTIONNAIRE START***************** */
export const getQuestionnaireStart = (getData: any) => ({
	type: questionnaireTypes.GET_QUESTIONNAIRE_START,
	payload: getData,
});

export const getQuestionnaireSuccess = (successData: any) => ({
	type: questionnaireTypes.GET_QUESTIONNAIRE_SUCCESS,
	payload: successData,
});

export const getQuestionnaireFailure = (failureData: any) => ({
	type: questionnaireTypes.GET_QUESTIONNAIRE_FAILURE,
	payload: failureData,
});

export const getQuestionnaireResponseReset = () => ({
	type: questionnaireTypes.GET_QUESTIONNAIRE_RESPONSE_RESET,
});

export const getQuestionnaireResponseChanged = () => ({
	type: questionnaireTypes.GET_QUESTIONNAIRE_RESPONSE_CHANGED,
});

/** ***************** GET QUESTIONNAIRE END ************ */

/** ***************** DELETE QUESTIONNAIRE START***************** */
export const deleteQuestionnaireStart = (getData: any) => ({
	type: questionnaireTypes.DELETE_QUESTIONNAIRE_START,
	payload: getData,
});

export const deleteQuestionnaireSuccess = (successData: any) => ({
	type: questionnaireTypes.DELETE_QUESTIONNAIRE_SUCCESS,
	payload: successData,
});

export const deleteQuestionnaireFailure = (failureData: any) => ({
	type: questionnaireTypes.DELETE_QUESTIONNAIRE_FAILURE,
	payload: failureData,
});

export const deleteQuestionnaireResponseReset = () => ({
	type: questionnaireTypes.DELETE_QUESTIONNAIRE_RESPONSE_RESET,
});

export const deleteQuestionnaireResponseChanged = () => ({
	type: questionnaireTypes.DELETE_QUESTIONNAIRE_RESPONSE_CHANGED,
});

/** ***************** DELETE QUESTIONNAIRE END ************ */

/** ***************** DELETE QUESTION START***************** */
export const deleteQuestionStart = (getData: any) => ({
	type: questionnaireTypes.DELETE_QUESTION_START,
	payload: getData,
});

export const deleteQuestionSuccess = (successData: any) => ({
	type: questionnaireTypes.DELETE_QUESTION_SUCCESS,
	payload: successData,
});

export const deleteQuestionFailure = (failureData: any) => ({
	type: questionnaireTypes.DELETE_QUESTION_FAILURE,
	payload: failureData,
});

export const deleteQuestionResponseReset = () => ({
	type: questionnaireTypes.DELETE_QUESTION_RESPONSE_RESET,
});

export const deleteQuestionResponseChanged = () => ({
	type: questionnaireTypes.DELETE_QUESTION_RESPONSE_CHANGED,
});

/** ***************** DELETE QUESTION END ************ */

/** ***************** FETCH MODULE START***************** */
export const fetchModuleListStart = (getData: any) => ({
	type: questionnaireTypes.FETCH_MODULE_LIST_START,
	payload: getData,
});

export const fetchModuleListSuccess = (successData: any) => ({
	type: questionnaireTypes.FETCH_MODULE_LIST_SUCCESS,
	payload: successData,
});

export const fetchModuleListFailure = (failureData: any) => ({
	type: questionnaireTypes.FETCH_MODULE_LIST_FAILURE,
	payload: failureData,
});

export const fetchModuleListReset = () => ({
	type: questionnaireTypes.FETCH_MODULE_LIST_RESET,
});

export const fetchModuleListChanged = () => ({
	type: questionnaireTypes.FETCH_MODULE_LIST_CHANGED,
});

/** ***************** FETCH MODULE END ************ */

/** ***************** ADD QUESTIONNAIRE START***************** */
export const addQuestionnaireStart = (getData: any) => ({
	type: questionnaireTypes.ADD_QUESTIONNAIRE_START,
	payload: getData,
});

export const addQuestionnaireSuccess = (successData: any) => ({
	type: questionnaireTypes.ADD_QUESTIONNAIRE_SUCCESS,
	payload: successData,
});

export const addQuestionnaireFailure = (failureData: any) => ({
	type: questionnaireTypes.ADD_QUESTIONNAIRE_FAILURE,
	payload: failureData,
});

export const addQuestionnaireResponseReset = () => ({
	type: questionnaireTypes.ADD_QUESTIONNAIRE_RESPONSE_RESET,
});

export const addQuestionnaireResponseChanged = () => ({
	type: questionnaireTypes.ADD_QUESTIONNAIRE_RESPONSE_CHANGED,
});

/** ***************** ADD QUESTIONNAIRE END ************ */

/** ***************** FETCH QUESTIONNAIRE START***************** */
export const fetchQuestionnaireStart = (getData: any) => ({
	type: questionnaireTypes.FETCH_QUESTIONNAIRE_START,
	payload: getData,
});

export const fetchQuestionnaireSuccess = (successData: any) => ({
	type: questionnaireTypes.FETCH_QUESTIONNAIRE_SUCCESS,
	payload: successData,
});

export const fetchQuestionnaireFailure = (failureData: any) => ({
	type: questionnaireTypes.FETCH_QUESTIONNAIRE_FAILURE,
	payload: failureData,
});

export const fetchQuestionnaireResponseReset = () => ({
	type: questionnaireTypes.FETCH_QUESTIONNAIRE_RESPONSE_RESET,
});

export const fetchQuestionnaireResponseChanged = () => ({
	type: questionnaireTypes.FETCH_QUESTIONNAIRE_RESPONSE_CHANGED,
});

/** ***************** FETCH QUESTIONNAIRE END ************ */

/** ***************** UPDATE QUESTIONNAIRE START***************** */
export const updateQuestionnaireStart = (getData: any) => ({
	type: questionnaireTypes.UPDATE_QUESTIONNAIRE_START,
	payload: getData,
});

export const updateQuestionnaireSuccess = (successData: any) => ({
	type: questionnaireTypes.UPDATE_QUESTIONNAIRE_SUCCESS,
	payload: successData,
});

export const updateQuestionnaireFailure = (failureData: any) => ({
	type: questionnaireTypes.UPDATE_QUESTIONNAIRE_FAILURE,
	payload: failureData,
});

export const updateQuestionnaireResponseReset = () => ({
	type: questionnaireTypes.UPDATE_QUESTIONNAIRE_RESPONSE_RESET,
});

export const updateQuestionnaireResponseChanged = () => ({
	type: questionnaireTypes.UPDATE_QUESTIONNAIRE_RESPONSE_CHANGED,
});

/** ***************** UPDATE QUESTIONNAIRE END ************ */
